import React from "react";
import VenueCard from "./VenueCard";
import Activities from "./Activities";
import "./Home.scss";

import logoColor from "../media/logos/logo-color.png";
import vid2 from "../HeroVid.webm";
import NavBar from "../Nav_Footer/NavBar";
import Footer from "../Nav_Footer/Footer";
import { Link } from "react-router-dom";
import useFadeIn from "../hooks/useFadeIn";



const HomePage = () => {
  const welcomeRef = useFadeIn();
  const igRef = useFadeIn();
  const tourRef = useFadeIn();
  const bookNowRef = useFadeIn();
  const activitiesLabelRef = useFadeIn();
  const venuesLabelRef = useFadeIn();

  return (
    <>
      <NavBar />
      <div className="homepage">
        {/* Video Section */}
        <div className="video-container">
          <video src={vid2} autoPlay muted loop className="intro-video" />

          <div className="cta-overlay">
            <div className="welcome-text">
              <h2>BOOK YOUR BOAT!</h2>
              <div className="links">
                <Link className="book-button" to="/booking">
                  Book Now
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div ref={welcomeRef} className="welcome fade-in">
          <img src={logoColor}></img>
          <div className="welcome-text">
            <h2>Welcome to</h2>
            <h2>El Gouna Sailing Club</h2>

            <p>
              Enjoy being our guest to experience a beach day like no other,
              endless water activities & sports, sailing classes for all ages,
              or book your private boat and party at sea.
            </p>
            <div className="links">
              <a
                className="ig"
                href="https://www.instagram.com/elgounasailingclub?igsh=MWNyYThpbzl0d3VhZQ%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a
                className="fb"
                href="https://www.facebook.com/share/5rWkrPpanencuja8/?mibextid=LQQJ4d"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a
                href="https://maps.app.goo.gl/VqCX6rMyVbf71xC28?g_st=com.google.maps.preview.copy"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-solid fa-location-dot"></i>
              </a>
            </div>
          </div>
        </div>
        <section ref={igRef} className="instagram-follow fade-in">
          <div className="instagram-text">
            <h2>FOLLOW US ON INSTAGRAM!</h2>
            <p>TO KNOW WHAT'S HAPPENING</p>
            <a
              href="https://www.instagram.com/elgounasailingclub?igsh=MWNyYThpbzl0d3VhZQ%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="instagram-button"
            >
              Visit Our Instagram
            </a>
          </div>
        </section>
        <section ref={tourRef} className="tour fade-in">
          <div className="tour-text">
            <h2>TAKE A VIRTUAL TOUR!</h2>
            <p>EXPLORE NOW</p>
            <a
              href="https://idvdigital.com/360-vr/elgouna-sailing/"
              target="_blank"
              rel="noopener noreferrer"
              className="tour-button"
            >
              Start Tour
            </a>
          </div>
        </section>
        <div ref={bookNowRef} className="book-now fade-in">
          <div className="welcome-text">
            <h2>DON'T MISS THE BOAT!</h2>
            <p>
              ENJOY AN AMAZING DAY AT SEA
            </p>
            <div className="links">
              <Link className="book-button" to="/booking">
                Book Now
              </Link>
            </div>
          </div>
        </div>

        <div ref={activitiesLabelRef} className="intro fade-in">
          <h2>ACTIVITIES</h2>
          <p>Click to learn more</p>
        </div>

        <Activities />
        <div ref={venuesLabelRef} className="intro intro--venues fade-in">
          <h2>VENUES</h2>
        </div>
        <VenueCard/>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
